import React, { useState, useEffect, PropsWithChildren } from "react";
import { useSelector, useDispatch } from "react-redux";
import QueryString from "query-string";
import SocialLogin from "../../components/SocialLogin";
import currentUserInfo from "../../selectors/currentUserInfo";
import { setProductType } from "../../actions/current";
import Signup from "../../components/Signup";
import { useMediaQuery } from "react-responsive";
import EmbeddedYTVideo from "../../components/home/EmbeddedYTVideo";
import {
  scrollToSignup,
  scrollToConfirmationCode,
} from "../../utils/scrollAnimations";
import GamesBuiltonBuildbox from "../../components/home/GamesBuiltonBuildbox";
import TryBuildbox from "../../components/home/TryBuildbox";
//import InlinePlans from "../../components/home/InlinePlans";
// import GamesOnBuildbox from "../../components/home/GamesOnBB";
import AwardSection from "../../components/home/AwardSection";
import { bbClassicFeatures } from "../../constants/bbClassicFeatures";
import GenericFeaturesHomePage from "../../components/home/GenericFeaturesHomePage";

import { testimonialsListSection } from "../../pages/Home";
import { TwoColumnInfoSection } from "../../components/home/TwoColumnInfoSection"
import { PlanIds } from "../../reducers/models";

import PromotionalBanner from "../../components/PromotionalBanner";
import styles from "../../styles/Home.module.scss";
import stylesReferral from "../../styles/ReferralPage.module.scss";
import { fetchSale } from "../../actions/sale";

interface HomeProps extends PropsWithChildren<any>{
  match: any;
  referralPage?: boolean;
}

export default function NewClassicStoryGamesHome(props: HomeProps) {
  const dispatch = useDispatch();

  const currentUser = useSelector(currentUserInfo);
  const [, setReferralCode] = useState("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [, setIsLoggedIn] = useState(false);
  const { match, referralPage = false } = props;

  const mobileBreakPoint = 769;

  useEffect(() => {
    const currentUrl = new URL(window.location.href);
    const urlQuery = QueryString.parse(currentUrl.search);
    sessionStorage.setItem("previousRoute", match.url);

    if (typeof urlQuery["mbsy"] === "string") {
      setReferralCode(urlQuery["mbsy"]);
    }
  }, [match.url]);

  useEffect(() => {
    // load sale info ASAP to streamline "try now" buttons
    dispatch(fetchSale());
  }, [dispatch]);
  
  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  });

  useEffect(() => {
    if (currentUser) {
      setIsLoggedIn(true);
    } else {
      dispatch(setProductType("generic"));
      sessionStorage.setItem("productType", "generic");
      sessionStorage.setItem("websocket-product", "generic");
      setIsLoggedIn(false);
    }
  }, [dispatch, currentUser]);

  const isDesktop = windowWidth >= mobileBreakPoint;

  const [showSignUp, setShowSignUp] = useState(false);
  const [confirmationData, setShowConfirmationForm] = useState(null);

  useEffect(() => {
    if (confirmationData !== null) {
      scrollToConfirmationCode();
    }
  }, [confirmationData]);
  const handleShowClick = () => {
    setShowSignUp(true);
  };

  useEffect(() => {
    if (showSignUp) {
      scrollToSignup(props, windowWidth);
    }

    // eslint-disable-next-line
  }, [showSignUp]);

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 769px)",
  });

  const headerText = () => {
    return (
      <div className={styles.headerText}>
        <h1 className={styles.title}>
          AI for Dreamers
          <br/>
          - No coding Needed
        </h1>
        <div className={styles.subtext}>
          Create 3D & 2D video games without coding.
        </div>
        <div style={{ margin: 0, padding: 0 }} className={styles.subtext}>
          Free. Easy To Use.
        </div>
      </div>
    );
  };

  return (
    <div className={referralPage ? styles.homeReferral : styles.home}>
      {isDesktop ? (
        <>
          <PromotionalBanner placement={"website_homepage"} router={props} />
          {referralPage && (
            <div className={stylesReferral.bottomHalf}>
              <div className={stylesReferral.content}>
                {!isDesktopOrLaptop && headerText()}
                <h1 className={stylesReferral.contentTitle}>
                  To get started, you will need to create an account below!
                </h1>
                <div className={stylesReferral.divider} />
                <div className={stylesReferral.fadeInItems} id={"expandable"}>
                  {showSignUp && (
                    <>
                      <div id={"signin"} />
                      <Signup
                        router={props}
                        isMigration={"false"}
                        fromBBClient={false}
                        // scrollToLogin={() => scrollToLogin(props, windowWidth)}
                        setShowConfirmationForm={setShowConfirmationForm}
                        confirmationData={confirmationData}
                        referral={true}
                      />
                    </>
                  )}
                  {!showSignUp && (
                    <button
                      className={stylesReferral.createManuallyBtn}
                      onClick={handleShowClick}
                    >
                      Create an Account Manually
                    </button>
                  )}
                  <SocialLogin
                    isBuildboxClient={false}
                    appleSignInAvailable={true}
                    largeButtons={true}
                  />
                </div>
              </div>
            </div>
          )}
            {/* "introducing storygames.ai" video <EmbeddedYTVideo videoId="VSrcRCgir2A" /> */}
            <EmbeddedYTVideo videoId="JB4WRlb6Zy4" />
            <TryBuildbox showText={false} planId={PlanIds.BB2Beginner} />
            {/* <GamesOnBuildbox /> */}
            <AwardSection />
            <GamesBuiltonBuildbox />
            <TwoColumnInfoSection {...testimonialsListSection} />
            {/* <InlinePlans homePage={true} productCategory={ProductCategory.BB2}/> */}
            <GenericFeaturesHomePage features={bbClassicFeatures} title={"Transform your game development with Buildbox Classic AI."} />
            <TryBuildbox showText={false} planId={PlanIds.BB2Beginner} />
          </>
      ) : (
        <>
          <PromotionalBanner placement={"website_homepage"} router={props} />
          {/* <GenAIPrompt /> */}
          {/*  "introducing storygames.ai" video <EmbeddedYTVideo videoId="VSrcRCgir2A" /> */}
          <EmbeddedYTVideo videoId="JB4WRlb6Zy4" />
          <TryBuildbox showText={false} planId={PlanIds.BB2Beginner} />
          {/* <GamesOnBuildbox /> */}
          <AwardSection />
          <GamesBuiltonBuildbox />
          <TwoColumnInfoSection {...testimonialsListSection} />
          {/* <InlinePlans homePage={true} productCategory={ProductCategory.BB2}/> */}
          <GenericFeaturesHomePage features={bbClassicFeatures} title={"Transform your game development with Buildbox Classic AI."} />
          <TryBuildbox showText={false} planId={PlanIds.BB2Beginner} />
        </>
      )}
    </div>
  );
}
